import styles  from './AdvertiseCard.module.scss'
import parse from'html-react-parser'
import { FormGroup, Input, Form } from 'reactstrap';

export default function AdvertiseCard({advertise, onSelected, check}) {
    
  return (
    <div 
        id={`advertise-${advertise.id}`}
        className={`bg-white p-4 mb-3 lgtBackground d-flex flex-row ${styles.advertiseCard}`} 
    >
         <div>
            <Form>
                <FormGroup>
                    <Input 
                        type='radio'
                        name='advertise' 
                        id={`radio-${advertise.id}`}
                        className='me-2'
                        value={advertise.id}
                        checked={check == advertise.id}
                        onChange={(e) => onSelected(e.target.value)}    
                        />
                </FormGroup>
            </Form>
        </div>
        <div className='d-flex flex-column'>
            <div>
                <span className={`fw-semibold me-2`}>
                    Title:
                </span>
                <span className={`text-primary`}>
                    {advertise.title}
                </span>
            </div>
            <div>
                <span className={`fw-semibold me-2`}>
                    Type:
                </span>
                <span>
                    {
                        advertise.type == 'DELAY_EXPIRE' 
                            ? 'Extra Day'
                            : advertise.type == 'FIRST_PLACE' && 'Top place'
                    }
                </span>
            </div>
            {
                advertise.type == 'DELAY_EXPIRE' &&
                    <div>
                        <span className={`fw-semibold me-2`}>
                            Date:
                        </span>
                        <span>
                            {advertise.expire_day}
                        </span>
                    </div>
            }
            {
                advertise.description &&
                    <div>
                        <span className={`fw-semibold me-2`}>
                            Description:
                        </span>
                        <div className={`d-inline-block`}>
                            {
                                parse(advertise.description)
                            }
                        </div>
                    </div>
            }
            <div>
                <span className={`fw-semibold me-2`}>
                    Price:
                </span>
                <span>
                    {advertise.price}
                </span>
            </div>
        </div>
    </div>
  )
}
